import { createEvent, restore, sample } from 'effector'
import { Disable2FA } from './types'
import { fx } from '../../../../libs'
import {
  setRequestError,
  setRequestSuccess,
} from '../../../../features/notifications'

export const submitDisable2FA = createEvent<Disable2FA>()

export const closeModal = createEvent()

export const disable2FA = fx<Omit<Disable2FA, 'clientId'>, void>({
  method: 'PUT',
  url: '/client/two_fa_disable/{clientId}',
})

sample({
  clock: submitDisable2FA,
  fn: (data) => {
    return {
      url: `/client/two_fa_disable/${data.clientId}`,
      body: {
        reason: data.reason,
        product: data.product,
      },
    }
  },
  target: disable2FA,
})

export const $isSuccessDisable = restore(
  disable2FA.doneData.map(() => true),
  false,
).reset(closeModal)

sample({
  clock: disable2FA.doneData,
  fn: () => {
    return true
  },
  target: [setRequestSuccess],
})

sample({
  clock: disable2FA.failData,
  fn: (failData) => {
    return { message: failData.body.message, code: failData.status }
  },
  target: [setRequestError],
})
